<script lang="ts">
  import { intersectionObserver } from '$lib/actions/intersection-observer';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { HeroSectionStoryblok } from '$types/bloks';
  import CenteredTitle from './marketing-sub-blocks/centered-title.svelte';
  import Collections from './marketing-sub-blocks/collections.svelte';
  import ImageWithCta from './marketing-sub-blocks/image-with-cta.svelte';
  import Images from './marketing-sub-blocks/images.svelte';
  import Video from './marketing-sub-blocks/video.svelte';

  export let block: HeroSectionStoryblok;
  let scroll = 0;
  let intersecting = true;
  $: animate = intersecting && block.parallax;
</script>

<svelte:window bind:scrollY={scroll} />

<section use:storyblokEditable={block} class="px-2 lg:px-8 !py-0">
  <div
    class="container mx-auto pt-8 relative"
    use:intersectionObserver={{
      callback: ([e]) => {
        intersecting = e.isIntersecting;
      },
      options: { threshold: [0] }
    }}
  >
    {#if block.title?.[0]}
      <div
        style:--y="{animate ? (scroll * 0.65).toFixed(2) : 0}px"
        class={cn('will-change-transform transform-gpu', animate && 'translate-y-[var(--y)]')}
      >
        <CenteredTitle as="h1" block={block.title?.[0]} />
      </div>
    {/if}

    {#each block.content as content}
      {#if content.component === 'images'}
        <Images {content} />
      {:else if content.component === 'video'}
        <Video {content} />
      {:else if content.component === 'collections'}
        <Collections {content} />
      {:else if content.component === 'image-with-cta'}
        <ImageWithCta {content} />
      {/if}
    {/each}
  </div>
</section>
